import rut from "@/helpers/rut";
import classNames from "classnames";
import Input from "../Input";
import Label from "../Label";
import { showJSONData } from "@/helpers/example";

const AssistantList = ({ onChange = () => {}, responsibleUser, assistants, onAction = () => {}, ...props }) => {
    return (
        <div {...props}>
            <h2 className="text-xl mb-4">Lista de asistentes</h2>

            <div className="w-full mb-3 flex justify-end">
                <div className="flex gap-1 items-center">
                    <Input
                        id="assumed_guest_select_all"
                        required
                        name="name"
                        type="checkbox"
                        handleChange={(event) => onAction(event.target.checked ? 'SELECT_ALL' : 'DESELECT_ALL')}
                    />
                    <Label forInput="assumed_guest_select_all" value="Seleccionar todo" />
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4">
                {[...Array(props.quantity)].map((_value, index) => {
                    const assistant = assistants.find(assistant => assistant.id === (index + 1));

                    return (
                        <div>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-3" key={`client-list-item-${index}`}>
                                <div>
                                    <Label forInput={`input-name-user-${assistant?.id}`} value="Nombre" />
                                    <Input
                                        id={`input-name-user-${assistant?.id}`}
                                        required
                                        value={assistant?.name}
                                        className="block w-full"
                                        placeholder="Nombre"
                                        name="name"
                                        handleChange={(event) => onChange(event, index)}
                                        disabled={assistant?.is_autocomplete}
                                    />
                                </div>
                                <div>
                                    <Label forInput={`input-lastname-user-${assistant?.id}`} value="Apellido" />
                                    <Input
                                        id={`input-lastname-user-${assistant?.id}`}
                                        required
                                        value={assistant?.lastname}
                                        className="block w-full"
                                        placeholder="Apellido"
                                        name="lastname"
                                        handleChange={(event) => onChange(event, index)}
                                        disabled={assistant?.is_autocomplete}
                                    />
                                </div>
                                <div>
                                    <Label forInput={`input-rut-user-${assistant?.id}`} value="R.U.N" />
                                    <Input
                                        id={`input-rut-user-${assistant?.id}`}
                                        required={!assistant?.assumed_guest}
                                        value={assistant?.rut}
                                        className={classNames("block w-full", {
                                            "cursor-not-allowed": assistant?.assumed_guest
                                        })}
                                        placeholder={assistant?.assumed_guest ? "Asistente" : "R.U.N"}
                                        name="rut"
                                        handleChange={(event) => onChange(event, index, {
                                            value: rut.format(event.target.value) === '-' ? '' : rut.format(event.target.value)
                                        })}
                                        disabled={assistant?.assumed_guest || assistant?.is_autocomplete}
                                    />
                                </div>
                            </div>
                            <div className="flex items-center gap-3 w-full">
                                <div className="flex items-center gap-1">
                                    <Input
                                        id={`input-assumed_guest-user-${assistant?.id}`}
                                        type="checkbox"
                                        checked={!assistant?.assumed_guest}
                                        name="assumed_guest"
                                        handleChange={(event) => onChange(event, index, {
                                            value: !assistant?.assumed_guest,
                                            extra: [
                                                {
                                                    name: 'rut',
                                                    value: ''
                                                }
                                            ]
                                        })}
                                        disabled={assistant?.is_autocomplete}
                                    />
                                    <Label forInput={`input-assumed_guest-user-${assistant?.id}`} value="Asume responsabilidad individual" />
                                </div>
                                {assistant?.id === 1 && (
                                    <div className="flex items-center gap-1">
                                        <Input
                                            id={`input-is_autocomplete-user-${assistant?.id}`}
                                            type="checkbox"
                                            checked={assistant?.is_autocomplete}
                                            name="is_autocomplete"
                                            handleChange={(event) => onChange(event, index, {
                                                extra: [
                                                    {
                                                        name: 'name',
                                                        value: responsibleUser.name
                                                    },
                                                    {
                                                        name: 'rut',
                                                        value: responsibleUser.rut,
                                                    },
                                                    {
                                                        name: 'lastname',
                                                        value: responsibleUser.lastname
                                                    }
                                                ]
                                            })}
                                        />
                                        <Label forInput={`input-is_autocomplete-user-${assistant?.id}`} value="Completar con los datos del responsable" />
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default AssistantList;
